shadow$provide[272] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Layer:{enumerable:true, get:function() {
  return Layer;
}}});
var require$_DOT__SLASH_transform_DOT_js = require("./transform.js");
class Layer extends require$_DOT__SLASH_transform_DOT_js.Transform {
  static initClass() {
    this.traits = ["node", "vertex", "layer"];
  }
  make() {
    this._listen("root", "root.resize", this.update);
    return this.uniforms = {layerScale:this._attributes.make(this._types.vec4()), layerBias:this._attributes.make(this._types.vec4()),};
  }
  update() {
    const camera = this._inherit("root").getCamera();
    const aspect = camera.aspect != null ? camera.aspect : 1;
    const fov = camera.fov != null ? camera.fov : 1;
    const pitch = Math.tan(fov * Math.PI / 360);
    const _enum = this.node.attributes["layer.fit"].enum;
    let {fit} = this.props;
    const {depth} = this.props;
    switch(fit) {
      case _enum.contain:
        fit = aspect > 1 ? _enum.y : _enum.x;
        break;
      case _enum.cover:
        fit = aspect > 1 ? _enum.x : _enum.y;
        break;
    }
    switch(fit) {
      case _enum.x:
        this.uniforms.layerScale.value.set(pitch * aspect, pitch * aspect, 1, 1);
        break;
      case _enum.y:
        this.uniforms.layerScale.value.set(pitch, pitch, 1, 1);
        break;
    }
    return this.uniforms.layerBias.value.set(0, 0, -depth, 0);
  }
  change(changed, touched, init) {
    if (changed["layer.fit"] || changed["layer.depth"] || init) {
      return this.update();
    }
  }
  vertex(shader, pass) {
    if (pass === 2) {
      return shader.pipe("layer.position", this.uniforms);
    }
    if (pass === 3) {
      return shader.pipe("root.position");
    }
    return shader;
  }
}
Layer.initClass();

};